<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-12-23 10:44:38
-->
<template>
  <RibbonButton
    :class="[
      'component--ribbon__drop-menu',
      expanded ? 'emnu-item-expaned' : null,
      disabled ? 'disabled' : null,
    ]"
    :size="size"
    :icon="icon"
    :iconClass="iconClass"
    @click.native="handleRootClick"
    :title="title"
  >
    <template slot="icon" v-if="!!$slots.icon">
      <slot name="icon"></slot>
    </template>
    <span class="font-12" slot="label">
      {{ text }}
      <i class="el-icon-caret-bottom"></i>
      <ul class="menu-items" v-show="expanded">
        <slot></slot>
      </ul>
    </span>
  </RibbonButton>
</template>

<script>
import { isAncestorOf } from "../../../utils/domHelper";
import RibbonButton from "./ribbonButton.vue";
export default {
  name: "ribbonDropMenu",
  componentName: "ribbonDropMenu",
  props: {
    icon: {
      type: String,
    },
    iconClass: {
      type: String,
    },
    text: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "small",
    },
    title: {
      type: String
    }
  },
  components: {
    RibbonButton,
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    handleRootClick() {
      if (this.disabled) return;
      this.expanded = true;
    },
  },
  mounted() {
    this.$on("item-click", (command) => {
      this.expanded = false;
      this.$emit("command", command);
    });
    this._windowClickHandler = (ev) => {
      if (!isAncestorOf(this.$el, ev.target) && this.expanded) {
        this.expanded = false;
      }
    };
    window.addEventListener("click", this._windowClickHandler);
  },
  destroyed() {
    window.removeEventListener("click", this._windowClickHandler);
  },
};
</script>

<style lang="scss">
.component--ribbon__drop-menu {
  position: relative;

  &.emnu-item-expaned {
    background: #409eff3d;
    border-color: #409eff6b;
  }

  .menu-items {
    position: absolute;
    left: -1px;
    background: white;
    padding: 6px 0;
    border: 1px solid #e1e7eb;
    border-radius: 4px;
    z-index: 9999;

    li {
      list-style-type: none;
      padding: 0 12px;
      margin: 0;
      line-height: 2;
      font-size: 12px;
      color: #606266;
      cursor: pointer;
      white-space: nowrap;
      text-align: left;

      &.disabled {
        opacity: 0.5;
        cursor: default;
      }

      &:not(.disabled):hover {
        background-color: #e5f2f2;
        color: #66b1ff;
      }
    }
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      background: unset;
      border-color: transparent;
    }
  }
}
</style>